<script>
  import { locations } from './data/locations';
  import { naics } from './data/naics';
  import { onMount } from 'svelte';
  import SearchDropdown from './components/SearchDropdown.svelte';
  
  let selectedLocation = '';
  let selectedIndustry = '';
  let isLocationDropdownOpen = false;
  let isIndustryDropdownOpen = false;
  let locationSearchTerm = '';
  let industrySearchTerm = '';
  let selectedLocationIndex = -1;
  let industryInput;

  function handleSearch() {
    const params = new URLSearchParams();
    
    if (selectedLocation) {
      params.set('location', selectedLocation);
    }
    if (selectedIndustry) {
      params.set('naicsCode', selectedIndustry);
    }

    window.location.href = `/listings?${params.toString()}`;
  }

  // Click outside handler
  function handleClickOutside(event) {
    // Only close dropdowns if clicking outside both search components
    const searchComponents = document.querySelectorAll('.relative.flex-1');
    const clickedInsideSearch = Array.from(searchComponents).some(
      component => component.contains(event.target)
    );
    
    if (!clickedInsideSearch) {
      isLocationDropdownOpen = false;
      isIndustryDropdownOpen = false;
    }
  }

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  // Update the SearchDropdown for locations to include shortform search
  function locationFilter(item, term) {
    const searchTerm = term.toLowerCase();
    return item.label.toLowerCase().includes(searchTerm) || 
           item.shortform.toLowerCase() === searchTerm ||
           item.value.toLowerCase().includes(searchTerm);
  }

  function handleLocationSelect(event) {
    console.log(event)
    if (event?.detail?.type === 'keyboard' && industryInput && industryInput.inputElement) {
      industryInput.inputElement.focus();
    }
  }

  // Add naicsFilter function
  function naicsFilter(item, term) {
    const searchTerm = term.toLowerCase();
    return item.label.toLowerCase().includes(searchTerm) || 
           item.value.toLowerCase().includes(searchTerm) ||
           item.shortform.toLowerCase().includes(searchTerm);
  }
</script>

<div class="max-w-6xl mx-auto p-4">
  <div class="rounded-xl p-10">
    <div class="flex flex-col md:flex-row gap-8">
      <SearchDropdown
        placeholder="Location"
        items={locations}
        bind:selectedValue={selectedLocation}
        bind:searchTerm={locationSearchTerm}
        bind:isOpen={isLocationDropdownOpen}
        bind:selectedIndex={selectedLocationIndex}
        filterFn={locationFilter}
        on:select={handleLocationSelect}
        inputPadding="48px"
        getIcon={(value) => {
          const location = locations.find(l => l.value === value);
          return location ? 
            `<img src="${location.flag}" alt="${location.label}" class="w-6 h-4 object-cover rounded-sm" />` 
            : '';
        }}
        textClass="text-lg"
      >
        <svelte:fragment slot="item" let:item>
          <div class="flex items-center gap-2">
            <img 
              src={item.flag} 
              alt={item.label}
              class="w-6 h-4 object-cover rounded-sm"
            />
            {item.label}
          </div>
        </svelte:fragment>
      </SearchDropdown>

      <SearchDropdown
        placeholder="Industry"
        items={naics}
        bind:selectedValue={selectedIndustry}
        bind:searchTerm={industrySearchTerm}
        bind:isOpen={isIndustryDropdownOpen}
        inputPadding="12px"
        filterFn={naicsFilter}
        itemDisplay={(item) => `${item.value} - ${item.label}`}
        bind:this={industryInput}
        textClass="text-lg"
      />

      <div class="flex items-end">
        <button
          class="w-full md:w-auto bg-amber-400 hover:bg-amber-500 text-white font-semibold py-4 px-8 text-lg rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 transition-all duration-200 shadow-md hover:shadow-lg"
          on:click={handleSearch}
        >
          <div class="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
            </svg>
            Search
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
